export const isPartial = object => object?.meta?.partial === true

export const fullObject = object => (isPartial(object) ? undefined : object)

// A trimmed record refreshes what the store holds instead of replacing it:
// into a full record it only updates the fields it carries (the record stays
// full), and into another trimmed record it pools the fields of both (the
// record stays trimmed), so a screen that trimmed differently keeps what it
// read. A full record always replaces whatever is held.
export const mergeReceived = (existing, received) =>
  isPartial(received) && existing
    ? {
        ...existing,
        attributes: { ...existing.attributes, ...received.attributes },
        relationships: { ...existing.relationships, ...received.relationships }
      }
    : received
